import { useOwnAccount } from '@/hooks/useOwnAccount.ts';
import { buildPersonalThemeCss, PERSONAL_THEME_COLORS, usePersonalPrimaryColorKey } from '@/utils/personal-theme.ts';

/**
 * Injects the current user's personal primary-color choice as a plain
 * `<style>` element in the component tree (not via react-helmet), so it
 * reliably lands in the DOM after the site-wide admin theme tag
 * (`src/init/soapbox-head.tsx`'s `<style id="theme">`, rendered via
 * Helmet into `<head>`) regardless of Helmet's own tag ordering --
 * equal-specificity `:root` blocks are decided by source order, and a
 * plain body-rendered style tag is guaranteed to come after anything
 * Helmet put in `<head>`.
 */
const PersonalThemeStyle: React.FC = () => {
  const { account } = useOwnAccount();
  const key = usePersonalPrimaryColorKey(account?.id);

  if (key === 'default') return null;

  const hex = PERSONAL_THEME_COLORS.find(c => c.key === key)?.hex;
  if (!hex) return null;

  const css = buildPersonalThemeCss(hex);
  if (!css) return null;

  // eslint-disable-next-line formatjs/no-literal-string-in-jsx
  return <style id='personal-theme'>{`:root{${css}}`}</style>;
};

export default PersonalThemeStyle;
